module.exports = __webpack_public_path__ + "img/af_no.dfafc927.png";